import { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { PaymentVoucherPopUp } from "./PaymentVoucherTable";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import SwalServices from "../../../services/swalServices/SwalServices";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import { PartyAccountPopUp } from "./PartyAccountPopUp";
import { isValidForm } from "../../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../../utils/Messages";
import moment from "moment";
import { decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import { permission } from '../../../utils/enums/ValidationMessage';
import DailyReportsServices from "../../../services/axiosServices/apiServices/DailyReportsServices";

class PaymentVoucher extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            selectedRow: null,
            urlId: 0,
            idCompany: 0,
            idUser: 0,
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            rowData: [],
            colDefs: [],
            prop: {},
            caption: "",
            colName: "",
            paginationPageSize: 50,
            rowHeight: 40,
            // Row and Columns are written in PaymentVoucherTable.js folder for all
            // Row and Columns are written in PaymentVoucherTable.js folder for all
            // Row and Columns are written in PaymentVoucherTable.js folder for all
            receiptDetails: {
                receiptNo: "",
                selectVendor: [],
                selectedVendorId: "",
                selectedVendorName: "",
                paymentDate: "",
                refNo: "",
                paymentMode: [],
                paymentModeId: 0,
                paymentModeName: "",
                selectBank: [],
                selectSeries: [],
                idBank: 0,
                bankName: "",
                chequeNo: "",
                chequeDate: "",
                outStandingBalance: 0,
                finalCurrentBalance: 0,
                pendingBalance: "",
                paidAmount: "",
                remarks: "",
                updateStatus: 0,
                idChequeBookMaster: 0,
                idChequeBookDetails: 0,
                chequeBookSeries: "",
                idPaymentMake: 0,
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                // selectVendor: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "vendor name"
                //         ),
                //     },
                // ],
                // selectedVendorId: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "vendor name"
                //         ),
                //     },
                // ],
                selectedVendorName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "vendor name"
                        ),
                    },
                ],
                paymentDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "patment date"
                        ),
                    },
                ],
                // refNo: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "reference no"
                //         ),
                //     },
                // ],
                // paymentMode: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "payment mode"
                //         ),
                //     },
                // ],
                // paymentModeId: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "payment mode"
                //         ),
                //     },
                // ],
                paymentModeName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "payment mode"
                        ),
                    },
                ],
                idBank: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "bank"
                        ),
                    },
                ],

                // idBank: 0,
                // bankName: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "bank"
                //         ),
                //     },
                // ],

                // chequeDate: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "cheque date"
                //         ),
                //     },
                // ],
                paidAmount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "paid amount"
                        ),
                    },
                ],
            },
            vendors: [
                // {
                //     id: 1,
                //     name: 'Sanjay'
                // },
            ],
            partyAccountList: [],
            paymentModeList: [],
            mainPaymentModeList: [],
            bankList: [],
            mainBankList: [],
            isPartyAccountPopUp: false,
            series: [],
            //mainSeries: [],
            // mainBankList: [],
            chequeNoList: [],
            mainChequeNoList: [],
            paymentModeolDefsColDefs: [
                {
                    field: "type",
                    headerName: "Type",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "partyACName",
                    headerName: "Party Ac Name",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            isSeriesPopUp: false,
            seriesColDefs: [
                {
                    field: "chequeBookSeries",
                    headerName: "Cheque Book Series",
                    minWidth: window.innerWidth * 0.11,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                // {
                //     field: "date",
                //     headerName: "Date",
                //     minWidth: window.innerWidth * 0.05,
                //     flex: 0.5,
                //     filter: true,
                //     floatingFilter: true,
                //     valueFormatter: (params) => {
                //         if (!params.value) return "";
                //         // const date = new Date(params.value);
                //         // return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
                //         return moment(params.value).format("DD-MM-YYYY");
                //     },
                // }
            ],
        };
        this.gridApi = null;
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            }
            else {
                return {};
            }
        });
    };

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
            this.resetFields();
        });
    };

    setOpenModel2 = () => {
        this.setState({ isPartyAccountPopUp: !this.state.isPartyAccountPopUp });

    };

    setOpenModel3 = () => {
        this.setState({ isSeriesPopUp: !this.state.isSeriesPopUp });
    };

    // setOpenModel3 = (popup) => {
    //     this.setState({ isSeriesPopUp: !this.state.isSeriesPopUp }, () => {
    //     });
    // };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        let list = this.state.rowData
        let maxIdPaymentMake = list.length > 0
            ? Math.max(...list.map(item => item.idPaymentMake))
            : 0;

        let receiptNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        let details = this.state.receiptDetails
        details.receiptNo = receiptNo
        this.setState({ isModalOpen: true, receiptDetails: details })
        //this.usp_Master_PartyAccountSelect();
        // this.usp_Master_PaymentModeSelect();
        // this.usp_Master_BankSelect();
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.openPopUpForUpdateItem(event);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };
    openPopUpForUpdateItem = () => {
        //this.usp_Master_PartyAccountSelect();
        this.setState({ isModalOpen: false }, () => {
            this.accountTransactionServices.usp_Transaction_PaymentMakeSelectbyId(this.state.receiptDetails.idPaymentMake).then((response) => {
                //debugger
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData !== null) {
                        //this.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(dynamicData.idBank, 1);
                        //this.usp_Master_ChequeBookNoSelectbyChequeBookSeries(dynamicData.idChequeBookMaster, 1, dynamicData.idPaymentMake);
                        let req = {
                            idBank: dynamicData.idBank,
                            updateStatus: 1,
                        };
                        this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(req).then((response) => {
                            if (response.statusCode === 200 && response.responseItem !== null) {
                                let data = response.responseItem.responseContent;
                                //let data = this.state.receiptDetails;
                                // data.outStandingBalance = dynamicData.finalVendorCurrentBalance;
                                // data.finalCurrentBalance = dynamicData.finalCurrentBalance;
                                this.setState({
                                    series: data
                                }, () => {
                                    //debugger
                                    let request = {
                                        idChequeBookMaster: dynamicData.idChequeBookMaster,
                                        updateStatus: 1,
                                        idPaymentMake: dynamicData.idPaymentMake,
                                    };
                                    this.accountTransactionServices.usp_Master_ChequeBookNoSelectbyChequeBookSeries(request).then((response) => {
                                        if (response.statusCode === 200 && response.responseItem !== null) {
                                            let chequeNoList = response.responseItem.responseContent;
                                            chequeNoList = chequeNoList.map((x) => ({
                                                id: x.idChequeBookDetails,
                                                name: x.chequeNo,
                                            }));
                                            this.setState({
                                                chequeNoList: chequeNoList,
                                                mainChequeNoList: chequeNoList,
                                            }, () => {
                                                //debugger;
                                                let receiptDetails = this.state.receiptDetails;
                                                receiptDetails.receiptNo = dynamicData.receiptNo;
                                                receiptDetails.selectedVendorId = dynamicData.idVendor;
                                                receiptDetails.selectedVendorName = this.state.partyAccountList?.find(item => item.idPartyAccount === dynamicData.idVendor)?.partyACName;
                                                receiptDetails.paymentDate = moment(dynamicData.date).format('YYYY-MM-DD');
                                                //receiptDetails.paymentDate = dynamicData.date;
                                                receiptDetails.refNo = dynamicData.refNo;
                                                receiptDetails.paymentModeId = dynamicData.paymentMode;
                                                receiptDetails.paymentModeName = this.state.paymentModeList?.find(item => item.id === dynamicData.paymentMode)?.name; //this.state.paymentModeList .;
                                                receiptDetails.idBank = dynamicData.idBank;
                                                receiptDetails.bankName = this.state.bankList?.find(item => item.id === dynamicData.idBank)?.name;
                                                receiptDetails.chequeDate = moment(dynamicData.chequeDate).format('YYYY-MM-DD');
                                                receiptDetails.outStandingBalance = dynamicData.outstandingBalance;
                                                receiptDetails.pendingBalance = dynamicData.pendingBalance;
                                                receiptDetails.paidAmount = dynamicData.amountRec;
                                                receiptDetails.remarks = dynamicData.remarks;
                                                receiptDetails.updateStatus = 1;
                                                receiptDetails.idChequeBookDetails = dynamicData.idChequeBookDetails;
                                                receiptDetails.chequeNo = this.state.chequeNoList?.find(item => item.id === dynamicData.idChequeBookDetails)?.name;
                                                //console.log("series", this.state.series);
                                                receiptDetails.idChequeBookMaster = dynamicData.idChequeBookMaster;
                                                receiptDetails.chequeBookSeries = this.state.series?.find(item => item.idChequeBookMaster === dynamicData.idChequeBookMaster)?.chequeBookSeries;
                                                receiptDetails.idPaymentMake = dynamicData.idPaymentMake;
                                                //this.SwalServices.Success("Save sucessfully.");
                                                this.setState({ receiptDetails: receiptDetails, isModalOpen: true });
                                            });
                                        }
                                    });
                                });

                                //});
                            }
                        });
                        // this.setState({
                        //     isModalOpen: true
                        // }, () => {

                        // });
                    } else {
                        //this.procSelectAllRecordsSP();
                    }
                }
            });
        })

        //this.setState({ isModalOpen: true });
        // this.usp_Master_PaymentModeSelect();
        // this.usp_Master_BankSelect();
    };

    handleCellClick = (event) => {
        //debugger;
        //if (event.colDef.field === "piQty") {
        let data = this.state.receiptDetails;
        data.idPaymentMake = event.data.idPaymentMake;
        this.setState({ receiptDetails: data });
        //this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Payment Voucher");
        //}
    };

    handleDropdownCellClick = (event) => {
        //debugger;
        //if (event.colDef.field === "piQty") {
        //this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Payment Voucher");
        //}
        let data = this.state.receiptDetails;
        data.selectedVendorId = event.data.idPartyAccount;
        data.selectedVendorName = event.data.partyACName;
        this.setState({ receiptDetails: data, isPartyAccountPopUp: !this.state.isPartyAccountPopUp }
            , () => {
                this.getClosingBalance();
            }
        );
    };

    handlSeriesDropdownCellClick = (event) => {
        //debugger;
        //if (event.colDef.field === "piQty") {
        //this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Payment Voucher");
        //}
        let data = this.state.receiptDetails;
        data.idChequeBookMaster = event.data.idChequeBookMaster;
        data.chequeBookSeries = event.data.chequeBookSeries;
        this.setState({ receiptDetails: data, isSeriesPopUp: !this.state.isSeriesPopUp }
            , () => {
                this.usp_Master_ChequeBookNoSelectbyChequeBookSeries(this.state.receiptDetails.idChequeBookMaster, this.state.receiptDetails.updateStatus, this.state.receiptDetails.idPaymentMake);
            }
        );
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect();
            });
        } else {
            // window.location.href = "/Login";
        }
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 100);
        window.addEventListener("resize", this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        //debugger;
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let data = this.state.receiptDetails;
            let requestData = {
                receiptNo: data.receiptNo, //"REC123",
                date: (data.paymentDate && data.paymentDate !== 'Invalid date') ? data.paymentDate : '',  //"2025-02-15T00:00:00Z",
                idVendor: data.selectedVendorId,
                paymentMode: data.paymentModeId,
                idBank: data.idBank, // Required field
                refNo: data.refNo, //"REF-456",
                idChequeBookMaster: data.idChequeBookMaster, // 12,
                idChequeBookDetails: data.idChequeBookDetails, // 34,
                chequeNo: data.chequeNo,  //"CHQ-789",
                chequeDate: (data.chequeDate && data.chequeDate !== 'Invalid date') ? data.chequeDate : '', // "2025-02-20T00:00:00Z",
                outstandingBalance: Number(data.outStandingBalance).toFixed(2), // 1500.25,
                amountRec: Number(data.paidAmount).toFixed(2), // 500.00,
                pendingBalance: Number(data.pendingBalance).toFixed(2), // 1000.25,
                idCompany: this.state.idCompany,
                e_Date: new Date().toISOString(), //"2025-02-15T10:30:00Z",
                e_IDUser: this.state.idUser,
                isUpdated: data.updateStatus === 1 ? 1 : 0,
                updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null, //"2025-02-16T12:00:00Z",
                u_IDUser: data.updateStatus === 1 ? this.state.idUser : 0, //9,
                isDeleted: 0,
                deletedDate: null,
                d_IDUser: 0,
                remarks: data.remarks, // "Payment received for invoice #456",
                //idFinancialYear: data.idFinancialYear
                updateStatus: data.updateStatus,
                dbIdChecque: data.idChequeBookDetails,
                idPaymentMake: data.updateStatus === 1 ? data.idPaymentMake : 0,
            };
            this.isSubmitting = true;
            this.setState({ isSaving: true });
            this.accountTransactionServices.usp_Transaction_PaymentMakeInsertAndUpdate(requestData).then((response) => {
                //debugger
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData !== null) {
                        if (this.state.receiptDetails.updateStatus === 1) {
                            this.SwalServices.Success("Updated sucessfully.");
                        } else {
                            this.SwalServices.Success("Save sucessfully.");
                        }
                        if (this.state.urlId) {
                            this.setState({ route: '/ledger-report' });
                        } else {
                            this.setState({
                                isModalOpen: false,
                                //receiptDetails: reset
                            }, () => {
                                this.resetFields();
                                this.procSelectAllRecordsSP();
                            });
                        }
                    } else {
                        this.procSelectAllRecordsSP();
                    }
                }
            }).finally(() => {
                this.isSubmitting = false;
                this.setState({ isSaving: false });
            });
        }
    };

    resetFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let reset = this.state.receiptDetails;
        reset.receiptNo = "";
        reset.paymentDate = "";
        reset.idVendor = "";
        reset.paymentMode = "";
        reset.idBank = "";
        reset.refNo = "";
        reset.idChequeBookMaster = "";
        reset.idChequeBookDetails = "";
        reset.chequeNo = "";
        reset.chequeDate = "";
        reset.outstandingBalance = "";
        reset.amountRec = "";
        reset.pendingBalance = "";
        reset.idCompany = "";
        reset.e_Date = "";
        reset.e_IDUser = "";
        reset.isUpdated = "";
        reset.updatedDate = "";
        reset.u_IDUser = "";
        reset.isDeleted = "";
        reset.deletedDate = "";
        reset.d_IDUser = "";
        reset.remarks = "";
        reset.updateStatus = 0;
        reset.idPaymentMake = 0
        reset.selectedVendorName = "";
        reset.paymentModeName = "";
        reset.bankName = "";
        reset.chequeBookSeries = "";

        this.setState({
            receiptDetails: reset, validState: validState
        }, () => {
            //this.procSelectAllRecordsSP();
        });
    }

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };


    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.receiptDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    this.setState({
                        partyAccountList: dynamicData,
                    }, () => {
                        this.usp_Master_PaymentModeSelect();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
                        }
                    });
                } else {
                    this.usp_Master_PaymentModeSelect();
                }
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay(); // Show loading overlay initially
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };

    usp_Master_PaymentModeSelect = () => {
        this.accountTransactionServices.usp_Master_PaymentModeSelect(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        id: x.idPaymentMode,
                        name: x.paymentMode,
                    }));
                    this.setState({
                        paymentModeList: dynamicData,
                        mainPaymentModeList: dynamicData
                    }, () => {
                        this.usp_Master_BankSelect();
                    });
                } else {
                    this.usp_Master_BankSelect();
                }
            }
        });
    }
    usp_Master_BankSelect = () => {
        this.accountTransactionServices.usp_Master_BankSelect(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                dynamicData = dynamicData.map((x) => ({
                    id: x.idBank,
                    name: x.bankName,
                }));
                this.setState({
                    bankList: dynamicData,
                    mainBankList: dynamicData
                });
            }
        });
    }

    // usp_Master_PartyAccountSelectOutstandingAmt = () => {
    //     let request = {
    //         IDPartyAccount: this.state.receiptDetails.selectedVendorId,
    //         IDCompany: this.state.idCompany
    //     };
    //     this.accountTransactionServices.usp_Master_PartyAccountSelectOutstandingAmt(request).then((response) => {
    //         if (response.statusCode === 200 && response.responseItem !== null) {
    //             let dynamicData = response.responseItem.responseContent;
    //             let data = this.state.receiptDetails;
    //             data.outStandingBalance = dynamicData.finalVendorCurrentBalance;
    //             data.finalCurrentBalance = dynamicData.finalCurrentBalance;
    //             data.paidAmount = dynamicData.finalVendorCurrentBalance > 0 ? dynamicData.finalVendorCurrentBalance : 0;
    //             this.setState({
    //                 receiptDetails: data
    //             });
    //         }
    //     });
    // }

    getClosingBalance = () => {
        const requestCopy = {
            fromDate: "2024-01-01",
            toDate: moment().format('YYYY-MM-DD'),
            partyId: this.state.receiptDetails.selectedVendorId,
            exponseById: 1,
            idCompany: this.state.idCompany,
        };

        this.dailyReportsServices.getLedgerReportRecords(requestCopy).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                const { openingBalance, openingBalanceType } = this.state;

                const openingValue = Number(openingBalance) || 0;
                const openingDR = openingBalanceType === "DR" ? openingValue : 0;
                const openingCR = openingBalanceType === "CR" ? openingValue : 0;

                let totalDebit = openingDR;
                let totalCredit = openingCR;

                response.responseItem.responseContent.forEach((item) => {
                    totalDebit += Number(item.debitAmount) || 0;
                    totalCredit += Number(item.creditAmount) || 0;
                });

                let closingAmount = 0;
                let closingType = "";

                if (totalDebit > totalCredit) {
                    closingAmount = totalDebit - totalCredit;
                    closingType = "DR";
                } else if (totalCredit > totalDebit) {
                    closingAmount = totalCredit - totalDebit;
                    closingType = "CR";
                }

                const closingBalance = closingAmount;
                let data = this.state.receiptDetails;
                data.outStandingBalance = closingBalance;
                data.paidAmount = closingBalance > 0 ? closingBalance : 0;
                this.setState({ closingBalance, receiptDetails: data });
            } else {
                this.SwalServices.showError(response.message);
            }
        }).catch((error) => {
            console.error("Error fetching closing balance:", error);
        });
    };

    usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake = (idBank, updateStatus) => {
        let request = {
            idBank: idBank,
            updateStatus: updateStatus,
        };
        this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                //let data = this.state.receiptDetails;
                // data.outStandingBalance = dynamicData.finalVendorCurrentBalance;
                // data.finalCurrentBalance = dynamicData.finalCurrentBalance;
                this.setState({
                    series: data
                });
            }
        });
    }

    usp_Master_ChequeBookNoSelectbyChequeBookSeries = (idChequeBookMaster, updateStatus, idPaymentMake) => {
        let request = {
            idChequeBookMaster: idChequeBookMaster,
            updateStatus: updateStatus,
            idPaymentMake: idPaymentMake,
        };
        this.accountTransactionServices.usp_Master_ChequeBookNoSelectbyChequeBookSeries(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                dynamicData = dynamicData.map((x) => ({
                    id: x.idChequeBookDetails,
                    name: x.chequeNo,
                }));
                this.setState({
                    chequeNoList: dynamicData,
                    mainChequeNoList: dynamicData,
                });
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Payment Voucher",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    //debugger;
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key === 'account' ? 'Party Name' : key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            minWidth: this.getColumnWidth(key),
                            hide: ["idPaymentMake", "chequeDate", "sR.No"].includes(key) ? true : false,
                            pinned: ["receiptNo", "date", "bankName", "account"].includes(key) ? "left" : undefined,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        // let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Payment Voucher",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            //this.procSelectAllRecord2GridviewSP(id, "Payment Voucher");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.receiptDetails;
        details.idPaymentMake = id;
        this.setState({ receiptDetails: details }, () => {
            this.openPopUpForUpdateItem();
        });
    };

    getColumnWidth = (key) => {
        const columnWidths = {
            "idPaymentReceive": window.innerWidth * 0.11,
            "sR.No": window.innerWidth * 0.06,
            "receiptNo": window.innerWidth * 0.07,
            "date": window.innerWidth * 0.07,
            "refNo": window.innerWidth * 0.06,
            "bankName": window.innerWidth * 0.17,
            "chequeNo": window.innerWidth * 0.06,
            "chequeDate": window.innerWidth * 0.08,
            "account": window.innerWidth * 0.1,
            "paymentMode": window.innerWidth * 0.06,
            "amountRec": window.innerWidth * 0.06,
            "remarks": window.innerWidth * 0.06,
            "approvalStatus": window.innerWidth * 0.08,
        };
        return columnWidths[key];
    };
    getPinnedWidth = (key) => {
        const pinnedWidths = {
            "sR.No": window.innerWidth * 0.05,
            "receiptNo": window.innerWidth * 0.06,
            "date": window.innerWidth * 0.07,
            "refNo": window.innerWidth * 0.05,
            "bankName": window.innerWidth * 0.2,
            "account": window.innerWidth * 0.13,
        }
        return pinnedWidths[key];
    }

    handleOnClick = (event, name) => {
        //debugger
        if (name === 'selectVendor') {
            this.setOpenModel2();
            //this.setState({ isPartyAccountPopUp: !this.state.isPartyAccountPopUp });
        } else if (name === 'selectSeries') {
            this.setOpenModel3();
            //this.setState({ isSeriesPopUp: !this.state.isSeriesPopUp });
        }
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.receiptDetails;
        if (name === 'paidAmount') {
            details.paidAmount = value;
            details.pendingBalance = details.outStandingBalance - details.paidAmount;
        } else {
            details[name] = value;
        }
        this.setState({ receiptDetails: details }, () => {
            //this.priceCalulate()
        });
    }

    handleSelectChange = (event, name) => {
        if (name === "selectBank") {
            //debugger
            let arr = [...this.state.mainBankList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.bankName = value;
            this.setState({ receiptDetails: data, bankList: found });
        } else if (name === 'paymentMode') {
            //debugger
            let arr = [...this.state.mainPaymentModeList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.paymentModeName = value;
            this.setState({ receiptDetails: data, paymentModeList: found });
        } else if (name === 'chequeNo') {
            //debugger
            let arr = [...this.state.mainChequeNoList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.receiptDetails;
            data.chequeNo = value;
            this.setState({ receiptDetails: data, chequeNoList: found });
        }
    }

    setFilterParametersTest = (id, name, drpIdentity) => {
        //var arr = [...this.state.ListSingleSelect]
        //if (id > 0) {
        //debugger;
        let data = this.state.receiptDetails;
        if (drpIdentity === 'paymentMode') {
            data.paymentModeId = id;
            data.paymentModeName = name;
        } else if (drpIdentity === 'selectBank') {
            data.idBank = id;
            data.bankName = name;
        } else if (drpIdentity === 'chequeNo') {
            data.idChequeBookDetails = id;
            data.chequeNo = name;
        }
        this.setState({
            receiptDetails: data,
        }, () => {
            if (drpIdentity === 'selectBank') {
                this.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(this.state.receiptDetails.idBank, this.state.receiptDetails.updateStatus);
            }
        });
        //}
    };

    render() {
        // const rowClassRules = {
        //     "selected-row": (params) => params.data.id === this.state.selectedRowId,
        // };

        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        return (
            <>
                <div className='payment-voucher'>
                    <div className="data-display">
                        <div className="data-display-inner relative">
                            <ButtonGrp buttons={['add', 'print', 'delete']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.openPopUpForUpdateItem(),
                                    print: this.handlePrint,
                                    delete: this.handleDelete,
                                }} />
                            <PaymentVoucherPopUp
                                partyAccountList={this.state.partyAccountList}
                                paymentModeList={this.state.paymentModeList}
                                bankList={this.state.bankList}
                                chequeNoList={this.state.chequeNoList}
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                close={this.closePopup.bind(this)}
                                handleChange={this.handleChange.bind(this)}
                                handleOnClick={this.handleOnClick.bind(this)}
                                handleSelectChange={this.handleSelectChange.bind(this)}
                                setFilterParametersTest={this.setFilterParametersTest.bind(this)}
                                receiptDetails={this.state.receiptDetails}
                                submit={this.submit.bind(this)}
                                isSaving={this.state.isSaving}
                                validState={this.state.validState}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Payment voucher</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        headerHeight={55}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onCellClicked={this.handleCellClick}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onGridReady={this.onGridReady}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    />
                                </div>
                            </div>
                            {/* <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={table2Data}
                                    columnDefs={table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true} // Enable pagination
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.state.onGridReady} // Rows per page
                                    onCellClicked={this.handleCellClick2}
                                />
                            </div>
                        </div> */}
                        </div>
                    </div>
                </div>
                <PartyAccountPopUp
                    modalName={"Party Account Name"}
                    partyAccountList={this.state.partyAccountList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.paymentModeolDefsColDefs}
                    isModalOpen={this.state.isPartyAccountPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />

                <PartyAccountPopUp
                    modalName={"Select Series"}
                    partyAccountList={this.state.series}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.seriesColDefs}
                    isModalOpen={this.state.isSeriesPopUp}
                    setOpenModel={this.setOpenModel3.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handlSeriesDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />

            </>
        )
    }
}
export default PaymentVoucher;